<!-- generic-statement-report.component.html -->
<section id="main" class="bg-light">
     <div id="generalStatementReportContainer" class="container">
          <h1 [innerHTML]="'GenericStatementReport' | translator:'invoice'">Generic Statement Report</h1>

          <div class="overlay" *ngIf="isDownloading">
               <h1 class="heading" [innerHTML]="'Loading' | translator:'base'">Loading...</h1>
               <img [alt]="'Loading' | translator:'base'" name="Loading" />
          </div>

          <div class="row">
               <div class="col-lg-8">
                    <div class="row gx-2">
                         <div class="col-12 mb-3">
                              <p [innerHTML]="'GenericStatementTxt' | translator:'invoice'">
                                   This report provides a detailed statement of an account with a non-zero balance and no current activity or invoice.
                              </p>
                         </div>
                         <div class="col-12 mb-3">
                              <div *ngIf="showReportDownloadedAlert"
                                   [ngClass]="'alert alert-success alert-dismissible fade ' + (showReportDownloadedAlert ? 'show' :'hide')"
                                   name="showReportDownloadedAlert"
                                   role="alert"
                              >
                                   <span [innerHtml]="'reportDownloadedAlertBody' | translator:'invoice'">
                                        The selected report has been downloaded to your browser.
                                   </span>
                                   <button type="button"
                                        class="btn-close"
                                        data-dismiss="alert"
                                        (click)="showReportDownloadedAlert=false"
                                        [ariaLabel]="'Close' | translator:'base'"
                                        [title]="'Close' | translator:'base'"
                                   >
                                        <span class="visually-hidden">X</span>
                                   </button>
                              </div>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="billingPeriod" class="form-label">
                                   <span [innerHTML]="'billingPeriod' | translator:'invoice'">Billing Period (mm/yyyy)</span>:
                                   <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                              </label>
                              <select class="form-select"
                                   name="billingPeriod"
                                   id="billingPeriod"
                                   [(ngModel)]="billingPeriod"
                              >
                                   <option *ngFor="let p of periodList" [value]="p">
                                        {{ p.substring(0,2) }}/{{ p.substring(2,6) }} 
                                        <span *ngIf="periodList.indexOf(p) === 0" [innerHtml]="'notFinal' | translator:'invoice'"> - NOT FINAL</span>
                                   </option>
                              </select>
                         </div>
                         <div class="col-12 mb-3">
                              <label for="reportType" class="form-label">
                                   <span [innerHTML]="'outputFormat' | translator:'invoice'">
                                        Output Format: (This report is only available in PDF format):
                                   </span>
                              </label>
                         </div>
                         <div class="col-6 mb-3">
                              <button class="btn btn-primary btn-strong"
                                   [innerHTML]="'downloadReport' | translator:'invoice'"
                                   [title]="'downloadReport' | translator:'invoice'"
                                   (click)="downloadReport()"
                                   [disabled]="!pageValid()"
                                   id="downloadReport"
                                   name="downloadReport"
                              >
                                   Request Report
                              </button>
                         </div>
                         <div class="col-6 mb-3">
                              <button routerLink="/billingReports"
                                   class="btn btn-secondary btn-strong"
                                   [innerHTML]="'returnBillingReports' | translator:'invoice'"
                                   [title]="'returnBillingReports' | translator:'invoice'"
                              >
                                   Return to Billing Reports
                              </button>
                         </div>
                    </div>
               </div>
               <div class="col-lg-4 order-lg-2 sidebar">
                    <app-dashboardsupport></app-dashboardsupport>
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <h2 class="card-title h5 mt-0" [innerHTML]="'Resources' | translator:'base'">Resources</h2>
                              <ul>
                                   <li *ngIf="companyType === 'MC'">
                                        <button (click)="openDocument('PSPMotorCarrierEnrollment')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [title]="'MAHEnrollAgreement' | translator:'base'"
                                                [innerHTML]="'MAHEnrollAgreement' | translator:'base'"
                                                name="MAHagreement"
                                                id="MAHagreement"
                                        >
                                             PSP Monthly Account Holder Enrollment Agreement
                                        </button>
                                   </li>
                                   <li *ngIf="companyType === 'ISP'">
                                        <button (click)="openDocument('ISPAccountHolderAgreement')"
                                                target="_blank"
                                                class="btn btn-link"
                                                [title]="'ISPEnrollAgreement' | translator:'base'"
                                                [innerHTML]="'ISPEnrollAgreement' | translator:'base'"
                                                name="ISPagreement"
                                                id="ISPagreement"
                                        >
                                             PSP Industry Service Provider Enrollment Agreement
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                                [title]="'DisclosureAndAuth' | translator:'base'"
                                                [innerHTML]="'DisclosureAndAuth' | translator:'base'"
                                                (click)="openDocument('PSPDisclosureandAuthorizationForm')"
                                                target="_blank"
                                                name="dna"
                                                id="dna"
                                        >
                                             Disclosure and Authorization Form
                                        </button>
                                   </li>
                                   <li>
                                        <button class="btn btn-link"
                                                (click)="openDocument('BillingGuide')"
                                                target="_blank"
                                                name="billingmanual"
                                                id="billingmanual"
                                                [title]="'billingManual' | translator:'payment'"
                                                [innerHTML]="'billingManual' | translator:'payment'"
                                        >
                                             Billing Manual
                                        </button>
                                   </li>
                              </ul>
                         </div>
                    </div>
               </div>
          </div>
     </div>
</section>